import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAccreditedBanksToListingClick } from '../../analytics/promos';
import { AccreditedBanks } from '../../components/AccreditedBanks';
import { IBankDesktopSchema } from '../../repositories/newbuilding-card/entities/newbuilding/BankDesktopSchema';
import { getBanks, getNewbuildingId } from '../../selectors/newbuilding';

export const AccreditedBanksContainer: React.FC = () => {
  const banks = useSelector(getBanks);
  const newbuildingId = useSelector(getNewbuildingId);

  const handleBankClick = React.useCallback(
    (bank: IBankDesktopSchema) => {
      trackAccreditedBanksToListingClick(bank, newbuildingId);
    },
    [newbuildingId],
  );

  if (!banks.length) {
    return null;
  }

  return <AccreditedBanks banks={banks} onBankClick={handleBankClick} />;
};
